import React, { useEffect, useState, useRef } from "react";

import { useLocation, useParams } from "react-router-dom";
import HeaderProject from "./HeaderProject";
import { useDispatch, useSelector } from "react-redux";
import { getProject } from "../../redux/features/projects/projectsSlice";
import PageSecurityCode from "./PageSecurityCode";
import PageCode from "./PageCode";
import LoadingSpinner from "../../assets/images/loading-200x200.svg";
import LoadingSpinnerLight from "../../assets/images/loading-200x200-light.svg";

const Project = ({ toggleColorScheme, computedColorScheme }) => {
  const dispatch = useDispatch();
  const { project } = useSelector((state) => state.projects);

  const location = useLocation();
  const projectId = location.state ? location.state.projectId : null; // Check if state exists before accessing projectId

  const { handle: initialId } = useParams(); // Get the initial id from the URL params
  const [id, setId] = useState(initialId); // State to hold the updated id

  useEffect(() => {
    // This useEffect will be triggered every time the URL params change
    // It will update the 'id' state with the latest value from the URL
    setId(initialId);
  }, [initialId]); // The dependency array ensures that the effect runs whenever 'initialId' changes

  const [isScrolled, setIsScrolled] = useState(false);

  const handleScroll = () => {
    // Check if the page is scrolled, you can adjust the threshold as needed
    const scrolled = window.scrollY > 45;

    // Update the state based on the scroll position
    setIsScrolled(scrolled);
  };

  useEffect(() => {
    // Attach the scroll event listener when the component mounts
    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures the effect runs only once on mount

  useEffect(() => {
    dispatch(getProject({ handle: id }));
  }, [id]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const [currentProject, setCurrentProject] = useState(null);
  useEffect(() => {
    if (project) {
      setCurrentProject(project[0]);
    } else return;
  }, [project]);
  // menu buttons scroll

  const [activeTab, setActiveTab] = useState("skynet");
  const skynetRef = useRef(null);
  const codeSecurityRef = useRef(null);
  const fundamentalsRef = useRef(null);
  const operationsRef = useRef(null);
  const governanceRef = useRef(null);
  const marketRef = useRef(null);
  const communityRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const refs = [
        skynetRef,
        codeSecurityRef,
        fundamentalsRef,
        operationsRef,
        governanceRef,
        marketRef,
        communityRef,
      ];

      refs.forEach((ref, index) => {
        if (ref.current) {
          // Ensure ref is not null
          const { top } = ref.current.getBoundingClientRect();
          const threshold = 140; // Adjust as needed
          if (top <= threshold) {
            setActiveTab(ref.current.id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleTabClick = (tab) => {
    let yOffset = -140; // Default offset

    // Change yOffset based on tab
    if (tab === "skynet") {
      yOffset = -240;
    }

    const ref =
      tab === "skynet"
        ? skynetRef
        : tab === "code-security"
        ? codeSecurityRef
        : tab === "fundamentals"
        ? fundamentalsRef
        : tab === "operations"
        ? operationsRef
        : tab === "governance"
        ? governanceRef
        : tab === "market"
        ? marketRef
        : communityRef;

    if (ref.current) {
      // Ensure ref is not null
      const y =
        ref.current.getBoundingClientRect().top + window.scrollY + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  if (isLoading) {
    return (
      <div className="loading-class">
        <img
          src={
            computedColorScheme === "dark"
              ? LoadingSpinner
              : LoadingSpinnerLight
          }
        />
      </div>
    );
  } else {
    return (
      <>
        <div className="min-w-0 flex-1 pb-[4.75rem] sm:pb-16 sm:px-8 px-4 2xl:px-16 mx-auto max-w-screen-2xl">
          <HeaderProject
            isScrolled={isScrolled}
            project={project}
            currentProject={currentProject}
            toggleColorScheme={toggleColorScheme}
            computedColorScheme={computedColorScheme}
            activeTab={activeTab}
            handleTabClick={handleTabClick}
          />
          <div className="mb-8 mt-4 flex flex-col gap-8">
            <PageSecurityCode
              skynetRef={skynetRef}
              currentProject={currentProject}
            />
            <PageCode codeSecurityRef={codeSecurityRef} />
            <div ref={fundamentalsRef} id="fundamentals">
              <div className="flex flex-col gap-3 sm:gap-4">
                <div class="hidden sm:block">
                  <button type="button" class="flex w-fit items-center gap-4">
                    <div class="rounded-lg p-[0.375rem] bg-neutral-5 dark:bg-neutral-95">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                        class="text-neutral-100 dark:text-neutral-0 transition-transform rotate-90"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="96 48 176 128 96 208"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></polyline>
                      </svg>
                    </div>
                    <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                      Fundamentals
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col gap-4 sm:p-4 sm:bg-neutral-5 sm:dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 sm:border"
                  style={{ minHeight: "420px" }}
                >
                  da
                </div>
              </div>
            </div>
            <div ref={operationsRef} id="operations">
              <div className="flex flex-col gap-3 sm:gap-4">
                <div class="hidden sm:block">
                  <button type="button" class="flex w-fit items-center gap-4">
                    <div class="rounded-lg p-[0.375rem] bg-neutral-5 dark:bg-neutral-95">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                        class="text-neutral-100 dark:text-neutral-0 transition-transform rotate-90"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="96 48 176 128 96 208"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></polyline>
                      </svg>
                    </div>
                    <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                      Operations
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col gap-4 sm:p-4 sm:bg-neutral-5 sm:dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 sm:border"
                  style={{ minHeight: "420px" }}
                >
                  da
                </div>
              </div>
            </div>
            <div ref={governanceRef} id="governance">
              <div className="flex flex-col gap-3 sm:gap-4">
                <div class="hidden sm:block">
                  <button type="button" class="flex w-fit items-center gap-4">
                    <div class="rounded-lg p-[0.375rem] bg-neutral-5 dark:bg-neutral-95">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                        class="text-neutral-100 dark:text-neutral-0 transition-transform rotate-90"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="96 48 176 128 96 208"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></polyline>
                      </svg>
                    </div>
                    <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                      Governance
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col gap-4 sm:p-4 sm:bg-neutral-5 sm:dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 sm:border"
                  style={{ minHeight: "420px" }}
                >
                  da
                </div>
              </div>
            </div>
            <div ref={marketRef} id="market">
              <div className="flex flex-col gap-3 sm:gap-4">
                <div class="hidden sm:block">
                  <button type="button" class="flex w-fit items-center gap-4">
                    <div class="rounded-lg p-[0.375rem] bg-neutral-5 dark:bg-neutral-95">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                        class="text-neutral-100 dark:text-neutral-0 transition-transform rotate-90"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="96 48 176 128 96 208"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></polyline>
                      </svg>
                    </div>
                    <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                      Market
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col gap-4 sm:p-4 sm:bg-neutral-5 sm:dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 sm:border"
                  style={{ minHeight: "420px" }}
                >
                  da
                </div>
              </div>
            </div>
            <div ref={communityRef} id="community">
              <div className="flex flex-col gap-3 sm:gap-4">
                <div class="hidden sm:block">
                  <button type="button" class="flex w-fit items-center gap-4">
                    <div class="rounded-lg p-[0.375rem] bg-neutral-5 dark:bg-neutral-95">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 256 256"
                        class="text-neutral-100 dark:text-neutral-0 transition-transform rotate-90"
                      >
                        <rect width="256" height="256" fill="none"></rect>
                        <polyline
                          points="96 48 176 128 96 208"
                          fill="none"
                          stroke="currentColor"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="16"
                        ></polyline>
                      </svg>
                    </div>
                    <div class="text-2xl font-semibold text-neutral-100 dark:text-neutral-0">
                      Community
                    </div>
                  </button>
                </div>
                <div
                  className="flex flex-col gap-4 sm:p-4 sm:bg-neutral-5 sm:dark:bg-neutral-95 border-neutral-20 dark:border-neutral-80 sm:border"
                  style={{ minHeight: "420px" }}
                >
                  da
                </div>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
        </div>
      </>
    );
  }
};

export default Project;
